import React from 'react'
import { IconContainer } from './Icon.styles.ts'

export type IconType =
  | 'document'
  | 'folder'
  | 'chevron_down'
  | 'chevron_up'
  | 'check'
  | 'search'
  | 'exclamation'
  | 'circle'
  | 'home'
  | 'projects'
  | 'budget'
  | 'estimates'
  | 'close'
  | 'download'
  | 'dollar'
  | 'check-document'
  | 'arrow_right'
  | 'clock'
  | 'chart_arrow'
  | 'calculate'
  | 'plus'
  | 'organization'
  | 'sidebar_left'
  | 'sidebar_right'

interface IconProps {
  type: IconType
  size?: number
  color?: string
  className?: string
}

export const Icon: React.FC<IconProps> = ({
  type,
  size = 16,
  color = 'currentColor',
  className
}) => {
  const renderIcon = () => {
    switch (type) {
      case 'document':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox={`0 0 24 24`}
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            <path d="M10 9H8"></path>
            <path d="M16 13H8"></path>
            <path d="M16 17H8"></path>
          </svg>
        )

      case 'plus':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2.9165 7H11.0832" stroke="currentColor" />
            <path d="M7 2.91666V11.0833" stroke="currentColor" />
          </svg>
        )

      case 'calculate':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_14_77)">
              <path d="M10.5002 1.16666H3.50016C2.85583 1.16666 2.3335 1.689 2.3335 2.33333V11.6667C2.3335 12.311 2.85583 12.8333 3.50016 12.8333H10.5002C11.1445 12.8333 11.6668 12.311 11.6668 11.6667V2.33333C11.6668 1.689 11.1445 1.16666 10.5002 1.16666Z" />
              <path d="M4.6665 3.5H9.33317" />
              <path d="M9.3335 8.16667V10.5" />
              <path d="M9.3335 5.83333H9.33933" />
              <path d="M7 5.83333H7.00583" />
              <path d="M4.6665 5.83333H4.67234" />
              <path d="M7 8.16667H7.00583" />
              <path d="M4.6665 8.16667H4.67234" />
              <path d="M7 10.5H7.00583" />
              <path d="M4.6665 10.5H4.67234" />
            </g>
            <defs>
              <clipPath id="clip0_14_77">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
        )

      case 'folder':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
          </svg>
        )

      case 'chevron_down':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 9L12 15L18 9"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'chevron_up':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 15L12 9L6 15"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'check':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        )
      case 'search':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.3-4.3"></path>
          </svg>
        )

      case 'exclamation':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="8" y2="12"></line>
            <line x1="12" x2="12.01" y1="16" y2="16"></line>
          </svg>
        )

      case 'circle':
        return (
          <svg
            width={size}
            height={size}
            stroke={color}
            strokeWidth="2"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        )

      case 'home':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 22V12H15V22"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'projects':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 11H15"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 15H15"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 19H15"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 5H19C20.1 5 21 5.9 21 7V17C21 18.1 20.1 19 19 19H5C3.9 19 3 18.1 3 17V7C3 5.9 3.9 5 5 5Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'budget':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 25 25"
            fill="none"
            stroke={color}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.4167 6.125H4.08334C2.95576 6.125 2.04167 7.03909 2.04167 8.16667V16.3333C2.04167 17.4609 2.95576 18.375 4.08334 18.375H20.4167C21.5443 18.375 22.4583 17.4609 22.4583 16.3333V8.16667C22.4583 7.03909 21.5443 6.125 20.4167 6.125Z"
              stroke={color}
              strokeWidth="2.04167"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.25 14.2917C13.3776 14.2917 14.2917 13.3776 14.2917 12.25C14.2917 11.1224 13.3776 10.2083 12.25 10.2083C11.1224 10.2083 10.2083 11.1224 10.2083 12.25C10.2083 13.3776 11.1224 14.2917 12.25 14.2917Z"
              stroke={color}
              strokeWidth="2.04167"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.125 12.25H6.13521M18.375 12.25H18.3852"
              stroke={color}
              strokeWidth="2.04167"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'chart_arrow':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 6.125H19.25V11.375"
              stroke={color}
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.25 6.125L11.8125 13.5625L7.4375 9.1875L1.75 14.875"
              stroke={color}
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      case 'clock':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 5.25V10.5L14 12.25"
              stroke={color}
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 19.25C15.3325 19.25 19.25 15.3325 19.25 10.5C19.25 5.66751 15.3325 1.75 10.5 1.75C5.66751 1.75 1.75 5.66751 1.75 10.5C1.75 15.3325 5.66751 19.25 10.5 19.25Z"
              stroke={color}
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'estimates':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <rect width="16" height="20" x="4" y="2" rx="2"></rect>
            <line x1="8" x2="16" y1="6" y2="6"></line>
            <line x1="16" x2="16" y1="14" y2="18"></line>
            <path d="M16 10h.01"></path>
            <path d="M12 10h.01"></path>
            <path d="M8 10h.01"></path>
            <path d="M12 14h.01"></path>
            <path d="M8 14h.01"></path>
            <path d="M12 18h.01"></path>
            <path d="M8 18h.01"></path>
          </svg>
        )

      case 'close':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke={color}
          >
            <path
              d="M10.5 3.5L3.5 10.5"
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 3.5L10.5 10.5"
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'download':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            stroke={color}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 8.75V1.75"
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75"
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.08325 5.83334L6.99992 8.75001L9.91659 5.83334"
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'dollar':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="0.875"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke={color}
          >
            <g clip-path="url(#clip0_14_230)">
              <path d="M5.25 9.625C7.66625 9.625 9.625 7.66625 9.625 5.25C9.625 2.83375 7.66625 0.875 5.25 0.875C2.83375 0.875 0.875 2.83375 0.875 5.25C0.875 7.66625 2.83375 9.625 5.25 9.625Z" />
              <path d="M7 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375C3.5 4.60706 3.59219 4.82962 3.75628 4.99372C3.92038 5.15781 4.14294 5.25 4.375 5.25H6.125C6.35706 5.25 6.57962 5.34219 6.74372 5.50628C6.90781 5.67038 7 5.89294 7 6.125C7 6.35706 6.90781 6.57962 6.74372 6.74372C6.57962 6.90781 6.35706 7 6.125 7H3.5" />
              <path d="M5.25 7.875V2.625" />
            </g>
            <defs>
              <clipPath id="clip0_14_230">
                <rect width={size} height={size} fill="white" />
              </clipPath>
            </defs>
          </svg>
        )

      case 'check-document':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            <path d="m9 15 2 2 4-4"></path>
          </svg>
        )

      case 'arrow_right':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.91663 7H11.0833"
              stroke={color}
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 2.91663L11.0833 6.99996L7 11.0833"
              stroke={color}
              strokeWidth="1.16667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'organization':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
          >
            <path d="M13.1248 1.45833H4.37484C3.56942 1.45833 2.9165 2.11125 2.9165 2.91666V14.5833C2.9165 15.3887 3.56942 16.0417 4.37484 16.0417H13.1248C13.9303 16.0417 14.5832 15.3887 14.5832 14.5833V2.91666C14.5832 2.11125 13.9303 1.45833 13.1248 1.45833Z" />
            <path d="M6.5625 16.0417V13.125H10.9375V16.0417" />
            <path d="M5.8335 4.375H5.84079" />
            <path d="M11.6665 4.375H11.6738" />
            <path d="M8.75 4.375H8.75729" />
            <path d="M8.75 7.29167H8.75729" />
            <path d="M8.75 10.2083H8.75729" />
            <path d="M11.6665 7.29167H11.6738" />
            <path d="M11.6665 10.2083H11.6738" />
            <path d="M5.8335 7.29167H5.84079" />
            <path d="M5.8335 10.2083H5.84079" />
          </svg>
        )

      case 'sidebar_left':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.97 15V9C21.97 4 19.97 2 14.97 2H8.96997C3.96997 2 1.96997 4 1.96997 9V15C1.96997 20 3.96997 22 8.96997 22H14.97C19.97 22 21.97 20 21.97 15Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.96997 2V22"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.97 9.43994L12.41 11.9999L14.97 14.5599"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      case 'sidebar_right':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.97 15V9C21.97 4 19.97 2 14.97 2H8.96997C3.96997 2 1.96997 4 1.96997 9V15C1.96997 20 3.96997 22 8.96997 22H14.97C19.97 22 21.97 20 21.97 15Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.97 2V22"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.96997 9.43994L10.53 11.9999L7.96997 14.5599"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )

      default:
        return null
    }
  }

  return <IconContainer className={className}>{renderIcon()}</IconContainer>
}
